export function getFormatDiscount() {
    const number = this;
    if (!Truthy(number))
        return undefined;
    const numberFormatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: number && number % 1 === 0 ? 0 : 2,
        maximumFractionDigits: number && number % 1 === 0 ? 0 : 2,
    });
    const formattedNumber = numberFormatter.format(number || 0);
    return formattedNumber;
}
;
//# sourceMappingURL=getDiscountFormat.js.map